import * as Sentry from '@sentry/react';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom';

import '@/i18n';

import './main.css';

import { App } from './app';
import { SENTRY_DSN, SENTRY_ENABLED, SENTRY_ENVIRONMENT, SENTRY_PROPAGATION_TARGETS } from './config';

Sentry.init({
  dsn: SENTRY_DSN,
  environment: SENTRY_ENVIRONMENT,
  enabled: SENTRY_ENABLED,
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: SENTRY_ENVIRONMENT === 'live' ? 0.1 : 1.0,
  tracePropagationTargets: SENTRY_PROPAGATION_TARGETS,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

const element = document.getElementById('root');
const root = createRoot(element as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
